(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("a6GFB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7a3cf85fea4c312f$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $exvWl = parcelRequire("exvWl");
parcelRequire("lLUSR");
function $7a3cf85fea4c312f$export$2e2bcd8739ae039({ children: children, style: style, postUrl: postUrl, form: form, novalidate: novalidate, clearOnSubmit: clearOnSubmit, reloadOnSubmit: reloadOnSubmit, jsonData: jsonData, isAuthorizedBroker: isAuthorizedBroker, setShowError: setShowError }) {
    const { reset: reset, setError: setError, handleSubmit: handleSubmit, clearErrors: clearErrors } = form;
    if (isAuthorizedBroker && setShowError != undefined) novalidate = true;
    async function onSubmit(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    formValues) {
        const resp = await fetch(postUrl, {
            method: "POST",
            body: jsonData ? JSON.stringify(formValues) : $7a3cf85fea4c312f$var$convertToFormData(formValues),
            headers: jsonData ? {
                "Content-Type": "application/json"
            } : {
                Accept: "*/*"
            }
        });
        if (resp.ok) {
            if (clearOnSubmit !== false) reset();
            else if (reloadOnSubmit === true) window.location.reload();
        } else {
            const serverErrorMessage = await $7a3cf85fea4c312f$var$parseServerErrorMsg(resp);
            setError("serverError", {
                type: "manual",
                message: serverErrorMessage
            });
        }
    }
    function handleClick() {
        setShowError(true);
    }
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $exvWl.FormProvider), {
        ...form,
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("form", {
            encType: jsonData ? "application/json" : "multipart/form-data",
            style: style,
            onSubmit: isAuthorizedBroker === true && setShowError != undefined ? handleSubmit(handleClick) : handleSubmit(onSubmit),
            onChange: ()=>clearErrors("serverError"),
            noValidate: novalidate,
            children: children
        })
    });
}
async function $7a3cf85fea4c312f$var$parseServerErrorMsg(resp) {
    let serverError = "Server error: see log for more info";
    if (resp.headers.get("content-type")?.includes("application/json")) {
        const data = await resp.json();
        serverError = data.Message || serverError;
    } else {
        const text = await resp.text();
        if (text && text.length < 100) serverError = text;
    }
    return serverError;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7a3cf85fea4c312f$var$convertToFormData(formValues) {
    const formData = new FormData();
    Object.keys(formValues).forEach((key)=>{
        if (!formValues[key]) return; // dont include field with without value
        if (typeof formValues[key] === "object") {
            const maybeFileList = formValues[key];
            if (maybeFileList.item && maybeFileList.item(0)) formData.append(key, maybeFileList.item(0));
            else if (maybeFileList[0]) formData.append(key, maybeFileList[0]);
            else // Array med strings
            formData.append(key, JSON.stringify(formValues[key]));
        } else formData.append(key, formValues[key]);
    });
    return formData;
}

});

})();
//# sourceMappingURL=Form.7bc9f4e8.js.map
